import $ from 'springbokjs-dom/lib/$';

export default function() {
    return $.createFragment();
}
